









































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import { FileUpload } from "../fileupload";
import {
    TransportDeviationCategory,
    TransportLoad,
    TransportTask,
    TransportUnitType,
} from "../models";

import {
    transportDeviationService,
    transportExecuteService,
    transportUnitTypeService,
} from "../services";

import LoadTransportPartEdit from "./LoadTransportPartEdit.vue";

@Component({
    components: {
        LoadTransportPartEdit
    }
})
export default class DeviationDialog extends Vue {
    @Prop() task!: TransportTask;
    @Prop() load!: null | TransportLoad;
    @Prop() defer!: boolean;

    get plannedQuantity() {
        return this.task.lines.length
            ? this.task.lines[0].amount
            : 0;
    }

    get plannedUnit() {
        return this.task.lines.length
            ? (this.task.lines[0].measureUnitCode || "").toUpperCase()
            : this.quantityUnit;
    }

    deviationCategories: null | TransportDeviationCategory[] = null;
    units = ["PCS", "KG", "M3"];
    unitTypes: null | TransportUnitType[] = null;

    selectedCategory: null | TransportDeviationCategory = null;
    categoryEditable = true;
    body = "";
    files = new FileUpload();
    unitNumber = "";
    unitType: TransportUnitType | null = null;
    sideDoors = false;
    sideRelease = false;
    securityChain = false;
    quantity = 0;
    remainingQuantity = 0;
    quantityUnit: string | null = null;
    waitHours: number | null = null;
    waitMinutes: number | null = null;
    workHours: number | null = null;
    workMinutes: number | null = null;

    get loadTransportParts() {
        if (!this.selectedCategory || !this.selectedCategory.readyTask || !this.load) {
            return null;
        }

        return this.load.transportParts;
    }

    get bodyRequired(): boolean {
        if (!this.selectedCategory) {
            return false;
        }

        return true;
    }

    saving = false;

    get canSubmit() {
        if (!this.selectedCategory) {
            return false;
        }

        if (this.selectedCategory.reportQuantity) {
            if (!this.quantityUnit) {
                return false;
            }
        }

        if (this.selectedCategory.missingUnit) {
            if (!this.unitType || !this.unitNumber) {
                return false;
            }
        }

        if (this.bodyRequired && !this.body) {
            return false;
        }

        return true;
    }

    required(value: any) {
        return !!value || this.$t("validationErrors.required");
    }

    async mounted() {
        this.files.scaleImages = true;

        const result = await Promise.all([
            transportDeviationService.listDeviationCategories(),
            transportUnitTypeService.listUnitTypes()
        ]);

        this.deviationCategories = result[0];
        this.unitTypes = result[1].items;

        if (this.defer) {
            const deferCategory = this.deviationCategories.find(c => c.deferTask);
            this.selectedCategory = deferCategory || null;
            this.categoryEditable = false;
        } else {
            this.deviationCategories = this.deviationCategories.filter(c => !c.deferTask);
        }

        if (this.task.lines.length) {
            this.quantityUnit = this.task.lines[0].measureUnitCode.toUpperCase();
        }
    }

    @Watch("files.inputFiles")
    async filesChanged() {
        await this.files.upload();
    }

    quantityChanged() {
        if (!this.remainingQuantity) {
            let quantity = this.plannedQuantity - this.quantity;

            if (quantity < 0) {
                quantity = 0;
            }

            this.remainingQuantity = quantity;
        }
    }

    getMinutes(hours: number | null, minutes: number | null): number | null {
        return hours && minutes
            ? hours + minutes / 60
            : (hours
                ? hours
                : (minutes ? minutes / 60 : null));
    }

    async save() {
        this.saving = true;

        let body = this.body;

        if (this.selectedCategory!.missingUnit) {
            const additionalFeatures: string[] = [];
            if (this.sideDoors) {
                additionalFeatures.push(this.$t("missingUnitDialog.sideDoors").toString());
            }
            if (this.sideRelease) {
                additionalFeatures.push(this.$t("missingUnitDialog.sideRelease").toString());
            }
            if (this.securityChain) {
                additionalFeatures.push(this.$t("missingUnitDialog.securityChain").toString());
            }
            body = `${this.$t("missingUnitDialog.unitNumber") + ": " + this.unitNumber}, ${this.$t("missingUnitDialog.unitType") + ": " + this.unitType!.typeName}${additionalFeatures.length > 0 ? ", " + this.$t("missingUnitDialog.additionalFeatures") + ": " + additionalFeatures.join(", ") : ""}, ${this.$t("deviationDialog.deviationDescription") + ": " + body}`;
        }

        await transportDeviationService.createDeviation({
            deviationCategoryId: this.selectedCategory!.deviationCategoryId,
            taskId: this.task.taskId,
            message: body,

            files: this.files.value ? JSON.stringify(this.files.value) : null as any, // FIXME C# 8

            quantity: this.selectedCategory!.reportQuantity
                ? this.quantity
                : (this.selectedCategory!.reportHours ? this.getMinutes(this.waitHours, this.waitMinutes) : null),
            quantityUnit: this.selectedCategory!.reportQuantity
                ? this.quantityUnit
                : null as any, // FIXME C# 8
            plannedQuantity: this.selectedCategory!.reportQuantity
                ? this.plannedQuantity
                : (this.selectedCategory!.reportHours ? this.getMinutes(this.workHours, this.workMinutes) : null),
            plannedQuantityUnit: this.selectedCategory!.reportQuantity
                ? this.plannedUnit
                : null as any, // FIXME C# 8
            remainingQuantity: this.selectedCategory!.reportQuantity
                ? this.remainingQuantity
                : null,
            remainingQuantityUnit: this.selectedCategory!.reportQuantity
                ? this.quantityUnit
                : null as any, // FIXME C# 8

            loadExecutionItems: this.loadTransportParts
                ? this.loadTransportParts
                    .map(ltp => ({ loadTransportPartId: ltp.loadTransportPartId, value: ltp.value }))
                : undefined
        });

        if (this.defer) {
            await transportExecuteService.deferTask(this.task.taskId, {});
        }

        this.$emit("reload");
    }
}
